import type { SVGProps } from "react";
import * as React from "react";

const SvgArrowUpCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M15.293 12.707a1 1 0 0 0 1.414-1.414zM12 8l.707-.707a1 1 0 0 0-1.414 0zm-4.707 3.293a1 1 0 1 0 1.414 1.414zM11 16a1 1 0 1 0 2 0zm10-4a9 9 0 0 1-9 9v2c6.075 0 11-4.925 11-11zm-9 9a9 9 0 0 1-9-9H1c0 6.075 4.925 11 11 11zm-9-9a9 9 0 0 1 9-9V1C5.925 1 1 5.925 1 12zm9-9a9 9 0 0 1 9 9h2c0-6.075-4.925-11-11-11zm4.707 8.293-4-4-1.414 1.414 4 4zm-5.414-4-4 4 1.414 1.414 4-4zM13 16V8h-2v8z"
    />
  </svg>
);
export default SvgArrowUpCircle;
